package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.InvitationOtpVerificationPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationOtpVerificationPresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationInvitationOtpVerificationPresenterFactory {
  @Provides
  @IntoSet
  public fun provideInvitationOtpVerificationPresenterFactoryFactoryMultibinding(invitationOtpVerificationPresenterFactory: InvitationOtpVerificationPresenterFactory): Presenter.Factory = invitationOtpVerificationPresenterFactory
}
